// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsSegmentablePropertyUsageResult = anyOf(
  objectOf({
    segmentable_property_count: number,
    segmentable_property_max: number,
  }),
  objectOf({})
);
